import React, { useContext } from 'react';
import { bool, func, arrayOf, string } from 'prop-types';
import { ButtonStyled } from '@nike/nike-design-system-components';
import { connect } from 'react-redux';

import { TableServerSideContext } from '~COMPONENTS/tableServerSide/TableServerSideContext';
import Modal from '../../../../modal/Modal';

import { MAX_CATALOG_INDEX } from '../../../catalogs/constants';
import { unindexCatalog as unindexCatalogAction } from '../../actions';

function UnIndexCatalogModal({ isOpen, closeModal, catalogIds, catalogNames, unindexCatalog }) {
  const { refreshTableData } = useContext(TableServerSideContext);

  const title =
    catalogIds.length === 0 && catalogNames.length === 0
      ? 'Error: Too Many Catalogs Selected'
      : `Un-Index ${catalogNames.length === 1 ? 'Catalog' : 'Catalogs'}?`;

  const content = () => {
    if (catalogIds.length === 0 && catalogNames.length === 0) {
      return (
        <p>A maximum of {MAX_CATALOG_INDEX} catalogs can be un-indexed at a time. Please reduce your selection.</p>
      );
    }

    if (catalogNames.length === 0) {
      return <p>Loading catalogs...</p>;
    }

    return (
      <>
        <p style={{ marginBottom: '1rem' }}>
          Are you sure you wish to un-index the selected{' '}
          {catalogNames.length === 1
            ? 'catalog? Doing so will stop these products from being listed.'
            : 'catalogs? Doing so will stop their products from being listed.'}
        </p>
        <ul>
          {catalogNames.map(name => (
            <li key={name}>{name}</li>
          ))}
        </ul>
      </>
    );
  };

  const footer = ({ isLoading, toggleIsLoading }) => {
    if (catalogIds.length === 0 && catalogNames.length === 0) {
      return null;
    }

    const handleUnindex = async () => {
      toggleIsLoading(true, 'Un-indexing Catalogs...');

      await Promise.all(catalogIds.map(id => unindexCatalog(id)));

      refreshTableData();

      toggleIsLoading(false);
      closeModal();
    };

    return (
      <>
        <ButtonStyled
          type='button'
          appearance='primary'
          className='responsive-button'
          onClick={handleUnindex}
          disabled={isLoading}
        >
          Yes
        </ButtonStyled>
        <ButtonStyled
          type='button'
          appearance='secondary'
          className='responsive-button'
          onClick={closeModal}
          disabled={isLoading}
        >
          Cancel
        </ButtonStyled>
      </>
    );
  };

  return <Modal title={title} content={content} footer={footer} isOpen={isOpen} closeModal={closeModal} />;
}

UnIndexCatalogModal.propTypes = {
  catalogIds: arrayOf(string).isRequired,
  catalogNames: arrayOf(string).isRequired,
  closeModal: func.isRequired,
  isOpen: bool.isRequired,
  unindexCatalog: func.isRequired
};

export default connect(null, {
  unindexCatalog: unindexCatalogAction
})(UnIndexCatalogModal);
